import $ from 'jquery';

window.clubSiteAdmin = window.clubSiteAdmin || {};
window.$ = window.jQuery = $;



// WEBPACK FOOTER //
// ./public/js/app/globalInit.js